import { NonEmpty } from '@aigc/components';
import { Tag } from 'antd';
import type { ImageTaskDto } from '../../task/model';
import { useCalcImageCost } from '../hook';

export const ImageCredit = (props: { task: ImageTaskDto }) => {
  const calcCost = useCalcImageCost();

  return (
    <NonEmpty
      value={calcCost(props.task)}
      render={(v) => <Tag variant="outlined">{v} 信用点</Tag>}
    ></NonEmpty>
  );
};
